// The main driver is supposed to be determined by the isMainDriver property, but we don't control the flag from the Samsara side.
// As such, we can have multiple or zero drivers sent with that parameter set to true.
// For our purposes, the main driver is the singular driver returned by the API, or the only driver with that parameter set to true.
// If there are multiple or zero drivers with the parameter set to true (or zero drivers at all), there is no main driver.

import { VehicleDriverLink } from '@tmx/data-access';

export function determineMainDriver(linkedDrivers: VehicleDriverLink) {
  if (linkedDrivers.vehicleDriverLinks.length === 1) {
    return linkedDrivers.vehicleDriverLinks[0];
  }
  const mainDrivers = linkedDrivers.vehicleDriverLinks.filter(
    (link) => link.isMainDriver
  );
  if (mainDrivers.length === 1) {
    return mainDrivers[0];
  }
  return null;
}
